import cn from 'classnames';
import { TrianglePointIcon } from '@/assets/icons/TrianglePointIcon';
import { Link } from '@/ui-components/atoms/Link/Link';
import { Text } from '@/ui-components/atoms/Text/Text';
import styles from './snapshotpopover.module.scss';

export type SnapshotAlertBannerTone = 'critical' | 'warning';

export interface SnapshotAlertBannerProps {
    ctaHref?: string;
    ctaLabel?: string;
    layout?: 'inline' | 'section';
    message: string;
    tone: SnapshotAlertBannerTone;
}

function WarningCircleIcon(): React.JSX.Element {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="10" cy="10" r="8.75" fill="none" stroke="currentColor" strokeWidth="2" />
            <path d="M10.5 12.5H9.5L9 9V5H11V9L10.5 12.5Z" fill="currentColor" />
            <path d="M9 14H11V16H9V14Z" fill="currentColor" />
        </svg>
    );
}

export function SnapshotAlertBanner({
    ctaHref,
    ctaLabel,
    layout = 'section',
    message,
    tone,
}: SnapshotAlertBannerProps): React.JSX.Element {
    const wrapperCn = cn(styles.snapshotAlertBannerWrapper, {
        [styles.snapshotAlertBannerWrapperInline]: layout === 'inline',
    });
    const bannerCn = cn(styles.snapshotAlertBanner, {
        [styles.snapshotAlertBannerCritical]: tone === 'critical',
        [styles.snapshotAlertBannerWarning]: tone === 'warning',
    });
    const iconCn = cn(styles.snapshotAlertBannerIcon, {
        [styles.snapshotAlertBannerIconCritical]: tone === 'critical',
        [styles.snapshotAlertBannerIconWarning]: tone === 'warning',
    });
    const messageCn = cn(styles.snapshotAlertBannerMessage, {
        [styles.snapshotAlertBannerMessageCritical]: tone === 'critical',
        [styles.snapshotAlertBannerMessageWarning]: tone === 'warning',
    });

    return (
        <div className={wrapperCn}>
            <div className={bannerCn}>
                <div className={iconCn}>
                    {tone === 'critical' ? <TrianglePointIcon /> : <WarningCircleIcon />}
                </div>
                <div className={styles.snapshotAlertBannerContent}>
                    <Text tag="p" className={messageCn}>
                        {message}
                    </Text>
                    {ctaLabel && (
                        <div className={styles.snapshotAlertBannerActions}>
                            <Link className={styles.snapshotAlertItemLink} href={ctaHref || '#'}>
                                {ctaLabel}
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
